import { metodoPrograma } from '../../../components/api'

export const listaCurvaCrescimento = () =>
  metodoPrograma('listaCurvaCrescimento', {})

export const listaPacientesCurvaCrescimento = ({ nmPaciente = '' }) =>
  metodoPrograma('listaPacientesCurvaCrescimento', { nmPaciente })

export const getCurvaCrescimento = ({ idCurvaCrescimento, tpSexo, tpCurva }) =>
  metodoPrograma('valoresCurvaCrescimento', {
    idCurvaCrescimento,
    tpSexo,
    tpCurva,
  })

export const listaCurvaCrescimentoPaciente = ({ idPaciente }) =>
  metodoPrograma('curvaCrescimentoPaciente', { idPaciente })
